import { render, staticRenderFns } from "./findPassword.vue?vue&type=template&id=2b7e1a6d&scoped=true"
import script from "./findPassword.vue?vue&type=script&lang=js"
export * from "./findPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7e1a6d",
  null
  
)

export default component.exports